import { LeaderboardsPageContainer } from '../../../../../../shared/scripts/ui_leaderboard/LeaderboardsPageContainer.tsx';
import { LeaderboardsPageData } from '../../../../../../shared/scripts/ui_leaderboard/LeaderboardsPageData.ts';
import { createLeaderboardsPageDataDeps } from '../../../../../../shared/scripts/ui_leaderboard/createLeaderboardsPageDataDeps.ts';
import { createLeaderboardsNavigationCtaConfig } from '../../../../../../shared/scripts/ui_leaderboard/createLeaderboardsNavigationCtaConfig.ts';
import { parseLeaderboardsUrlState } from '../../../../../../shared/scripts/ui_leaderboard/parseLeaderboardsUrlState.ts';
import { mountUIReactComponent } from '../../../../../../shared/scripts/ui_platform/mountUIReactComponent.tsx';
import { UIUtilsEjsVariables } from '../../../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { navigateToPage } from '../../../../../../shared/scripts/ui_utils/ClientUtils.ts';
import { showTranslucentOverlay } from '../../../../../../shared/scripts/ui_overlays/showTranslucentOverlay.ts';
export class UIMLeaderboardController {
    static getInitialState() {
        const rankedMode = parseLeaderboardsUrlState(window.location.pathname).rankedModeType;
        return rankedMode != undefined ? {
            rankedModeType: rankedMode
        } : {};
    }
    static featureCheck() {
        const div = document.createElement('div');
        if (div.replaceChildren == undefined) {
            showTranslucentOverlay({
                title: {
                    key: 'strings:leaderboardPage.updateBrowser.title'
                },
                body: {
                    key: 'strings:leaderboardPage.updateBrowser.body'
                },
                onConfirm: ()=>navigateToPage('/')
            });
            throw new Error('Failed to create leaderboard: Browser does not support required features.');
        }
    }
    constructor(){
        UIMLeaderboardController.featureCheck();
        const data = new LeaderboardsPageData(createLeaderboardsPageDataDeps({
            manageHistory: false
        }), {
            hideMembership: UIUtilsEjsVariables.shouldHideStoreOnMobile,
            initialState: UIMLeaderboardController.getInitialState()
        });
        mountUIReactComponent('leaderboard_root', LeaderboardsPageContainer).render({
            data: data,
            ctaConfig: createLeaderboardsNavigationCtaConfig()
        });
    }
}
